// extracted by mini-css-extract-plugin
export default {"modal":"CR-z","error":"DR-z","disabled":"ER-z","fields":"FR-z","errorMsg":"GR-z","footer":"HR-z","formContentWrapper":"IR-z","productImage":"JR-z","overlay":"KR-z"};